/* eslint-disable react/prop-types */
import React from 'react';
import { AButton } from 'components/Antd';
import classes from './FilterDropdown.module.scss';

const FilterDropdownFooter = ({ onReset, onApply }) => {
  return (
    <div className={classes.filterDropdownFooter}>
      <AButton type="primary" onClick={onApply}>Apply</AButton>
      <AButton onClick={onReset} type="default">Reset</AButton>
    </div>
  );
}

export default FilterDropdownFooter;